/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-07-26 19:21:17
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";
import "./index.css";
import { BsyWidget } from "../BsyWidget";
import { BsyUtils } from "../../utils/Utils";

export default class BsyUser extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-user",
    items: [],
    width: 350,
    height: 34,
    value: null,
    islinkQuery: !1,
    allowBlank: !0,
    noRepeat: !1,
    editable: !1,
    count: 100,
    limit: [],
    // dynamicKey: window.FX.USER_ID.CurrentUser,
    dynamicType: "select",
    onStopEdit: null,
    onBeforeEdit: null,
    type: "user",
  };

  constructor(props) {
    super(props);
    this.state = {
      title: React.language("widget.user.listTitle"),
      msg: React.language("widget.user.clickToSelect1"),
      waterMark: React.language("content.empty"),
      dynamicFields: [
        {
          id: window.FX.USER_ID.CurrentUser,
          name: React.language("widget.user.current"),
          type: "member",
        },
      ],
      ...props,
      value: this.getValueId(props.value),
    };
    BsyUtils._initUserMap(props.items);
    this.value = this.getValueId(props.value);
    this.element = React.createRef();
  }

  componentDidMount = () => {
    super.componentDidMount();
    this.listMemberName();
  };

  _getDynamicFields = () => {
    return this.options.dynamicFields;
  };

  listMemberName = () => {
    const { value, ftoken } = this.state;
    if (ftoken) {
      return;
    }
    let that = this;
    if (BsyUtils.isObjectEmpty(value)) {
      return;
    }
    if (value === window.FX.USER_ID.CurrentUser && window.FX.STATIC.user) {
      let id = window.FX.STATIC.user
        ? window.FX.STATIC.user.dock_userid
          ? window.FX.STATIC.user.dock_userid
          : window.FX.STATIC.user._id
        : "";
      let name = window.FX.STATIC.user ? window.FX.STATIC.user.nickname : "";
      let avatarurl = window.FX.STATIC.user
        ? window.FX.STATIC.user.avatarurl
        : "";
      window.userSelectMap[id] = window.userSelectMap[id] || {
        id: id,
        avatarurl: avatarurl,
        name: name,
        type: "user",
      };
      if (avatarurl) {
        window.userSelectMap[id].avatarurl = avatarurl;
      }
      that.value = id;
      that.setState({ value: id });
      return;
    }
    if (window.userSelectMap[value]) {
      that.setState({ value: value });
      return;
    }

    React.axios("/corp/list_member_name", {
      members: [value],
    })
      .then((res) => {
        let a = res.data;
        let d = [];
        if (a.virtually && a.virtually.length > 0) {
          BsyUtils.forEach(a.virtually, function (k, z) {
            switch (z.mode) {
              case "role":
                a.roles || (a.roles = []);
                a.roles.push(z);
                break;
              case "outsider":
                a.outsiderMember || (a.outsiderMember = []);
                a.outsiderMember.push(z);
                break;
              case "member":
                a.users || (a.users = []);
                a.users.push(z);
                break;
              case "outsiderGroup":
                a.outsiderGroup || (a.outsiderGroup = []);
                a.outsiderGroup.push(z);
                break;
              case "current":
              case "currentSub":
                a.job_title || (a.job_title = []);
                a.job_title.push(z);
                break;
              case "relationUser":
                a.userRelation || (a.userRelation = []);
                a.userRelation.push(z);
                break;
              case "relationDept":
                a.deptRelation || (a.deptRelation = []);
                a.deptRelation.push(z);
                break;
              case "deptSub":
              case "dept":
                a.departments || (a.departments = []);
                a.departments.push(z);
                break;
              default:
                break;  
            }
          });
        }
        BsyUtils.forEach(a.users, function (a, b) {
          d.push({
            id: b._id,
            avatarurl: b.avatarurl,
            name: BsyUtils._toDeptUser(b, "user"),
            type: "user",
          });
        });
        BsyUtils.forEach(a.dockuser, function (a, b) {
          d.push({
            id: b._id,
            avatarurl: b.avatarurl,
            name: BsyUtils._toDeptUser(b, "user"),
            type: "dockuser",
          });
        });
        BsyUtils.forEach(a.outsiderMember, function (a, b) {
          d.push({
            id: b._id,
            avatarurl: b.avatarurl,
            name: BsyUtils._toDeptUser(b, "outsiderMember"),
            type: "outsiderMember",
          });
        });
        let items = d;
        BsyUtils.forEach(items, function (t, i) {
          i && (window.userSelectMap[i.id] = window.userSelectMap[i.id] || i);
        });
        that.setState({ value: value });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  onClick = () => {
    let a = this,
      b = this.options;

    if (a.isEnabled()) BsyUtils.applyFunc(a, b.onBeforeEdit, [this], !1);

    let c = new window.FX.ConfirmDialog({
      title: React.language("widget.user.listTitle"),
      height: 588,
      width: 956,
      contentWidget: {
        rowSize: [451],
        colSize: [926],
        padding: 15,
        items: [
          [
            {
              widgetName: b.name || b.widgetName,
              type: b.type,
              
              editable: !0,
              limit: b.limit,
              limitWidget: b.limitWidget,
              dynamicType: b.dynamicType,
              dynamicFields: b.dynamicFields,
              dynamicKey: b.dynamicKey,
              is_dock_form: b.is_dock_form,
              items: a.items,
              value: a.value,
              appId: b.appId,
              formId: b.formId,
              entryId: b.entryId,
              formMode: b.formMode,
            },
          ],  
        ],
      },
      onCustmElement: function (element) {
        if (b.type === "usergroup") {
          window
            .$('<div class="clean-select" />')
            .append('<i className="icon-bsy-clean" />')
            .append("<span >" + React.language("clean.select.item") + "</span>")
            .on("click", function (e) {
              let d = c.getWidgetByName(b.name || b.widgetName);
              BsyUtils.forEach(
                d.$selectList.find(".select-item"),
                function (a1, b1) {
                  let dd = window.$(b1).data("item");
                  if (dd) {
                    d._removeSelectItem(dd);
                  }
                }
              );
              d.refresh();
            })
            .appendTo(element);
        }
      },
      onClose: function () {
        BsyUtils.applyFunc(a, b.onClose, [a.value], !1);
      },
      onOk: function () {
        let d = c.getWidgetByName(b.name || b.widgetName);
        a.value = b.value = d.getValue();
        a.items = d.getItems();
        window.userSelectMap = { ...window.userSelectMap, ...d.selectMap };
        let info = null;
        if (a.options.type === "user") {
          if (window.userSelectMap[a.value]) {
            info = window.userSelectMap[a.value];
          }
        } else {
          if (!BsyUtils.isObjectEmpty(a.value)) {
            info = [];
            for (let i = 0; i < a.value.length; i++) {
              let id = a.value[i];
              if (window.userSelectMap[id]) {
                window.userSelectMap[id].name = window.userSelectMap[
                  id
                ].name.replace(" " + React.language("deling"), "");
                info.push(window.userSelectMap[id]);
              }
            }
          }
        }

        a.setState(
          {
            value: a.value,
          },
          () => {
            BsyUtils.applyFunc(a, b.onStopEdit, [a.value, info, a], !1);
          }
        );

        return !1;
      },
    });
    c.show();
  };

  renderBody = () => {
    const { value, islinkQuery, ftoken, msg } = this.state;
    let item = null;
    let bg = {};
    if (value) {
      item = window.userSelectMap[value];
      if (item && (item.name || item.nickname))
        bg = BsyUtils.formatUserThumb(item.name || item.nickname);
    }

    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.user")}
        </div>
      );
    } else {
      if (BsyUtils.isObjectEmpty(item)) {
        item = { id: value };
      }

      return (
        <ul className="select-list" onClick={this.onClick}>
          {value && item ? (
            <li className="select-item" id={value}>
              {item && item.avatarurl ? (
                <img className="user-center" alt="" src={item.avatarurl}></img>
              ) : BsyUtils.isObjectEmpty(bg) ? (
                ""
              ) : (
                <span className={"table-user-portrait-name color-" + bg.color}>
                  <span>{bg.name[0]}</span>
                </span>
              )}
              <span>{BsyUtils._toDeptUser(item)}</span>
            </li>
          ) : (
            <div className="select-empty">{msg}</div>
          )}
        </ul>
      );
    }
  };

  getValue = () => {
    // const i = window.userSelectMap[this.value] ? window.userSelectMap[this.value].id : this.value;
    return this.value;
  };

  checkValidate = () => {
    const { ftoken } = this.state;
    this.setInvalidateTypeText("");
    if (ftoken) {
      this.setInvalidateTypeText(React.language("form.item.error.format"));
      return !1;
    }
    var a = this.options;
    return !BsyUtils.isObjectEmpty(this.getValue()) || a.allowBlank;
  };
  getValueId = (a) => {
    let ftoken = window.FX.STATIC.FTOKEN;

    if (!a) {
      return (this.value = null);
    }

    if (ftoken) {
      if (a.hasOwnProperty("_id") || a.hasOwnProperty("id")) {
        this.value = a._id || a.id;
      } else {
        this.value = a;
      }
      return this.value;
    }

    window.userSelectMap = window.userSelectMap || {};
    if (this.value === window.FX.USER_ID.CurrentUser && window.FX.STATIC.user) {
      let id = window.FX.STATIC.user
        ? window.FX.STATIC.user.dock_userid
          ? window.FX.STATIC.user.dock_userid
          : window.FX.STATIC.user._id
        : "";
      let name = window.FX.STATIC.user ? window.FX.STATIC.user.nickname : "";
      let avatarurl = window.FX.STATIC.user
        ? window.FX.STATIC.user.avatarurl
        : "";
      a.hasOwnProperty("_id") || (a.hasOwnProperty("id") && (a._id = id));
      window.userSelectMap[id] = window.userSelectMap[id] || {
        id: id,
        avatarurl: avatarurl,
        name: name,
        type: "user",
      };
      if (avatarurl) {
        window.userSelectMap[id].avatarurl = avatarurl;
      }
      this.value = id;
      return this.value;
    }

    if (a.hasOwnProperty("_id") || a.hasOwnProperty("id")) {
      this.value = a._id || a.id;
      window.userSelectMap[this.value] = a;
    } else {
      this.value = a;
    }
    return this.value;
  };

  setValue = (a) => {
    if (a) {
      if (BsyUtils.isObjectEmpty(a)) {
        a = null;
      }
    }

    this.value = this.getValueId(a);
    this.setState(
      {
        value: this.value,
      },
      () => {
        this.listMemberName();
      }
    );
  };

  renderDisablePane = () => {
    const { value, islinkQuery, ftoken, appId, is_dock_form } = this.state;
    let item = null;
    let bg = {};
    if (value) {
      item = window.userSelectMap[value];
      if (item && (item.name || item.nickname))
        bg = BsyUtils.formatUserThumb(item.name || item.nickname);
    }
    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.user")}
        </div>
      );
    }

    if (BsyUtils.isObjectEmpty(item)) {
      return (
        <div
          className="bsy_form_item_disable"
          data-watermark={React.language("content.empty")}
        ></div>
      );
    }

    return (
      <div
        className={"bsy_form_item_disable "}
        data-watermark={React.language("content.empty")}
      >
        {value && item ? (
          <ul className="select-list">
            {" "}
            <li
              className="select-item"
              id={value}
              onClick={(e) => {
                BsyUtils.showUserInfo(null, item, e, appId, is_dock_form);
              }}
            >
              {item && item.avatarurl ? (
                <img className="user-center" alt="" src={item.avatarurl}></img>
              ) : BsyUtils.isObjectEmpty(bg) ? (
                ""
              ) : (
                <span className={"table-user-portrait-name color-" + bg.color}>
                  <span>{bg.name[0]}</span>
                </span>
              )}
              <span>{BsyUtils._toDeptUser(item)}</span>
            </li>{" "}
          </ul>
        ) : (
          ""
        )}
      </div>
    );
  };

  render() {
    const { cssName, css } = this.options;

    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }
    return (
      <div className={cssName} style={css} ref={this.element}>
        {this.renderBody()}
      </div>
    );
  }
}
